import { defineAsyncComponent } from 'vue'
export default {
  challenge: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/challenge.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  "error-layout": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/error-layout.vue").then(m => m.default || m))
}